export default function LogoSquares({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
      <path d="M.96 0h8.485a.96.96 0 0 1 .96.96v8.485a.96.96 0 0 1-.96.96H.96a.96.96 0 0 1-.96-.96V.96A.96.96 0 0 1 .96 0" />
      <path d="M.96 14.736h8.606a.96.96 0 0 1 .96.96v8.606a.96.96 0 0 1-.96.96H.96a.96.96 0 0 1-.96-.96v-8.606a.96.96 0 0 1 .96-.96" />
      <path d="M.96 29.474h8.606a.96.96 0 0 1 .96.96v8.606a.96.96 0 0 1-.96.96H.96a.96.96 0 0 1-.96-.96v-8.606a.96.96 0 0 1 .96-.96" />
      <path d="M15.696 0h8.606a.96.96 0 0 1 .96.96v8.606a.96.96 0 0 1-.96.96h-8.606a.96.96 0 0 1-.96-.96V.96a.96.96 0 0 1 .96-.96" />
      <path d="M15.696 29.474h8.606a.96.96 0 0 1 .96.96v8.606a.96.96 0 0 1-.96.96h-8.606a.96.96 0 0 1-.96-.96v-8.606a.96.96 0 0 1 .96-.96" />
      <path d="M30.434 0h8.606a.96.96 0 0 1 .96.96v8.606a.96.96 0 0 1-.96.96h-8.606a.96.96 0 0 1-.96-.96V.96a.96.96 0 0 1 .96-.96" />
      <path d="M30.434 14.736h8.606a.96.96 0 0 1 .96.96v8.606a.96.96 0 0 1-.96.96h-8.606a.96.96 0 0 1-.96-.96v-8.606a.96.96 0 0 1 .96-.96" />
      <path d="M30.434 29.474h8.606a.96.96 0 0 1 .96.96v8.606a.96.96 0 0 1-.96.96h-8.606a.96.96 0 0 1-.96-.96v-8.606a.96.96 0 0 1 .96-.96" />
    </svg>
  );
}
